import { Trans } from "@lingui/react/macro";
import { Stack, Text } from "@mantine/core";
import { useEffect, useRef } from "react";
import { Turnstile } from "react-turnstile";

const TURNSTILE_SITE_KEY = import.meta.env.VITE_CLOUDFLARE_TURNSTILE_SITE_KEY;

/**
 * @callback OnGetTokenCb
 * @param {string | null} token
 */

/**
 * @param {Object} params
 * @param {OnGetTokenCb} [params.onGetToken]
 * @param {number} [params.resetSignal] Increment to invalidate the current token and request a fresh challenge (e.g. after a failed API call consumed the token).
 */
export function HumanVerification({ onGetToken = () => {}, resetSignal = 0 }) {
	const widgetRef = useRef(null);
	const onGetTokenRef = useRef(onGetToken);

	useEffect(() => {
		onGetTokenRef.current = onGetToken;
	});

	useEffect(() => {
		if (!resetSignal) return;
		widgetRef.current?.reset();
		onGetTokenRef.current(null);
	}, [resetSignal]);

	return (
		<Stack gap="0" data-testid="human-verification">
			<Text size="sm">
				<Trans>Verificación humana</Trans>
			</Text>
			<Turnstile
				ref={widgetRef}
				sitekey={TURNSTILE_SITE_KEY}
				onVerify={(token) => {
					onGetToken(token);
				}}
				refreshExpired="auto"
			/>
		</Stack>
	);
}
